var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgYellowDangerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14827_64941)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.7971 16.891C21.3739 17.8283 20.6499 19 19.4978 19H4.50141C3.34713 19 2.62644 17.8265 3.20213 16.891L10.7004 4.70269C11.2775 3.76492 12.7229 3.76662 13.299 4.70269L20.7971 16.891ZM11.9997 14.3711C11.2058 14.3711 10.5622 14.9745 10.5622 15.7188C10.5622 16.463 11.2058 17.0664 11.9997 17.0664C12.7936 17.0664 13.4372 16.463 13.4372 15.7188C13.4372 14.9745 12.7936 14.3711 11.9997 14.3711ZM10.6349 9.52697L10.8668 13.5113C10.8776 13.6978 11.042 13.8438 11.2412 13.8438H12.7583C12.9574 13.8438 13.1218 13.6978 13.1327 13.5113L13.3645 9.52697C13.3762 9.32559 13.2052 9.15625 12.9901 9.15625H11.0093C10.7942 9.15625 10.6232 9.32559 10.6349 9.52697Z",
    fill: "#FFAB00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14827_64941"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 15,
    fill: "white",
    transform: "translate(3 4)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowDangerIcon);
export default __webpack_public_path__ + "static/media/YellowDangerIcon.3fc94f4ff963a77c311c96e4105d4650.svg";
export { ForwardRef as ReactComponent };